module.exports = __webpack_public_path__ + "static/media/twitter.0743ea04.svg";